/**
 * Ingreso al Módulo TIME. La clave se manda al back y nunca queda en estado
 * después del intento.
 */

import { useState } from 'react';
import { LogIn, Loader2 } from 'lucide-react';

import { mensajeDe } from '../../api';
import { Aviso } from '../../components/Aviso';
import { useSesion } from '../../components/useSesion';

export function Ingreso(): React.JSX.Element {
  const { ingresar } = useSesion();
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(ev: React.FormEvent): Promise<void> {
    ev.preventDefault();
    setEnviando(true);
    setError(null);
    try {
      await ingresar(usuario, clave);
    } catch (err) {
      setError(mensajeDe(err));
    } finally {
      setClave('');
      setEnviando(false);
    }
  }

  return (
    <section className="ingreso">
      {/* El símbolo va sobre la tarjeta blanca y no sobre el navy del fondo:
          es navy, y ahí desaparecería. */}
      <img src="/simbolo-azul.png" alt="CodyLog" />
      <p className="rubro">Recursos Humanos</p>
      <h2>Portal RRHH</h2>
      <p className="nota">Ingresá con tu usuario del portal.</p>

      <form onSubmit={(ev) => void enviar(ev)}>
        <label className="campo">
          Usuario
          <input
            type="text"
            autoComplete="username"
            required
            value={usuario}
            onChange={(ev) => setUsuario(ev.target.value)}
          />
        </label>
        <label className="campo">
          Clave
          <input
            type="password"
            autoComplete="current-password"
            required
            value={clave}
            onChange={(ev) => setClave(ev.target.value)}
          />
        </label>
        <button type="submit" disabled={enviando}>
          {enviando ? (
            <Loader2 className="girando" size={16} aria-hidden="true" />
          ) : (
            <LogIn size={16} aria-hidden="true" />
          )}
          {enviando ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>

      {error !== null && <Aviso tono="error">{error}</Aviso>}
    </section>
  );
}
